import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';

const slice = createSlice({
  name: 'paymentFormInUse',
  initialState: false,
  reducers: {
    setPaymentFormInUse(state, action: PayloadAction<boolean>) {
      return action.payload;
    },
  },
});

export const { setPaymentFormInUse } = slice.actions;

export default slice.reducer;
